export const formatNumberInINR = (number: number): string => {
  return new Intl.NumberFormat('en-IN')?.format(number);
}